export default "__VITE_ASSET__Duo5hKQ4__"